import { render, staticRenderFns } from "./ResultCell.vue?vue&type=template&id=53590c38&"
import script from "./ResultCell.vue?vue&type=script&lang=js&"
export * from "./ResultCell.vue?vue&type=script&lang=js&"
import style0 from "./ResultCell.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports